import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { useStatusStore } from "@/stores/status";
import { HttpStatusCode } from "@/lib/enums";
import i18nConfig from "@/locales/i18n";

//En commentaire les formulaire pas encore fini
const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			name: "home",
			component: HomeView,
		},
		{
			path: "/cellules-souches",
			name: "Cellules souches",
			component: () =>
				import("../views/CellulesSouches/FormCellulesSouches.vue"),
		},
		{
			path: "/commmande-cordon",
			name: "Commande de matériel pour le sang de cordon",
			component: () => import("../views/CommandeCordon/FormCommandeCordon.vue"),
		},
		{
			path: "/adresse",
			name: "changement d'adresse",
			component: () => import("../views/FormAdresse/FormChangementAdresse.vue"),
		},
		{
			path: "/demande-renseignements",
			name: "Demande de renseignements",
			component: () => import("../views/Renseignements/RenseignementsForm.vue"),
		},
		{
			path: "/benevoles",
			name: "Bénévoles",
			component: () => import("../views/Benevoles/BenevolesForm.vue"),
		},
		{
			path: "/educationhq",
			name: "Éducation HQ",
			component: () => import("../views/Education/FormEducationHQ.vue"),
		},
		{
			path: "/recherche",
			name: "Recherche",
			component: () => import("../views/SangRecherche/SangRechercheForm.vue"),
		},
		{
			path: "/Suivi-PosteGreffe",
			name: "Demande de Suivi post greffe autologue",
			component: () => import("../views/SuiviPostGreffeAutologue/SuiviPostGreffeAutologueForm.vue"),
		},
		{
			path: "/Suivi-PosteGreffe-CH/:id?",
			props: true,
			name: "Demande de Suivi post greffe autologue Centre Hospitalier",
			component: () => import("../views/SuiviPostGreffeAutologue/SuiviPostGreffeAutologueCHForm.vue"),
		},
		{
			path: "/liste-suivi-posteGreffe",
			name: "Liste des demandes de Suivi post greffe autologue Centre Hospitalier",
			component: () => import("../views/LandingPageCSP/LandingPageCSP.vue"),
		},
		{
			path: "/status/:type",
			component: () => import("@/components/Status/StatusViewer.vue"),
		},
		{
			path: "/commmande-cordon/confirmation",
			name: "Confirmation de Commande de matériel pour le sang de cordon",
			component: () => import("../views/CommandeCordon/ConfirmationCommandeCordon.vue"),
		},
		{
			path: "/lait-maternel",
			name: "Lait maternel",
			component: () => import("../views/LaitMaternel/FormLaitMaternel.vue"),
		},
		{
			path: "/sang-cordon",
			name: "Sang de cordon",
			component: () => import("../views/SangCordon/FormSangCordon.vue"),
		},
		{
			path: "/:pathMatch(.*)*",
			redirect: "/status/404",
		},
	],
});

router.beforeEach(async (to: any) => {
	const statusStore = useStatusStore();
	//On exclut les routes qui ne nécessitent pas d'être authentifié
	const routeExcludedAction = [
		"/status/500",
		"/status/401",
		"/status/404"
	];

if (routeExcludedAction.includes(to.path.toString().toLowerCase())) {
	if (to.path.startsWith("/status")) {
		let message = "";
		let type = HttpStatusCode.InternalServerError;
		//dépendamment du code d'erreur on ajuste le message et le type d'erreur
		switch (to.path.toLowerCase().substring(11, 8)) {
			case HttpStatusCode.InternalServerError.toString():
				message = i18nConfig.i18n.global.t("status.InternalServerError");
				type = HttpStatusCode.InternalServerError;
				break;
			case HttpStatusCode.NotAuthorized.toString():
				message = i18nConfig.i18n.global.t("status.NotAuthorized");
				type = HttpStatusCode.NotAuthorized;
				break;
			case HttpStatusCode.NotFound.toString():
				message = i18nConfig.i18n.global.t("status.NotFound");
				type = HttpStatusCode.NotFound;
				break;

			default:
				break;
		}
		//Les infos d'erreur sont stockés dans le magasin pour que la vue statusViewer puisse les afficher
		statusStore.SetStatus(
			i18nConfig.i18n.global.t("app.commun.error") +
				" " +
				to.path.toLowerCase().substring(11, 8),
			message,
			type
		);
	}
}

});



export default router;
